<!-- ── CHIP MODE ────────────────────────────────────────────────────────────── -->
<ng-container *ngIf="mode === 'chip'">
  <div class="ai-chip-list">
    <div *ngFor="let item of displayed" class="ai-chip-wrap">
      <div class="ai-chip">
        <span class="ai-chip-label">{{ itemLabel(item) }}</span>
        <span *ngIf="item.status" class="ai-chip-status" [ngClass]="statusClass(item.status)">
          {{ item.status }}
        </span>
      </div>
      <!-- Hover card -->
      <div class="ai-tooltip">
        <div class="ai-tooltip-label">{{ itemLabel(item) }}</div>
        <div class="ai-tooltip-id" *ngIf="item.actionItemId">{{ item.actionItemId }}</div>
        <div class="ai-tooltip-grid">
          <ng-container *ngIf="item.taskId">
            <span class="ai-tl">Task</span><span class="ai-tv">{{ item.taskId }}</span>
          </ng-container>
          <ng-container *ngIf="item.assetTag || item.assetId">
            <span class="ai-tl">Asset</span><span class="ai-tv">{{ assetRef(item) }}</span>
          </ng-container>
          <ng-container *ngIf="item.assetName">
            <span class="ai-tl">Asset name</span><span class="ai-tv">{{ item.assetName }}</span>
          </ng-container>
          <ng-container *ngIf="(item.assetCategories ?? []).length">
            <span class="ai-tl">Categories</span><span class="ai-tv">{{ categoriesLabel(item) }}</span>
          </ng-container>
          <ng-container *ngIf="item.status">
            <span class="ai-tl">Status</span>
            <span class="ai-tv">
              <span class="ai-badge" [ngClass]="statusClass(item.status)">{{ item.status }}</span>
            </span>
          </ng-container>
          <ng-container *ngIf="item.assigned">
            <span class="ai-tl">Assigned</span><span class="ai-tv">{{ assignedLabel(item) }}</span>
          </ng-container>
          <ng-container *ngIf="item.evidenceRequired">
            <span class="ai-tl">Evidence</span><span class="ai-tv">Required</span>
          </ng-container>
        </div>
      </div>
    </div>

    <div *ngIf="overflow > 0" class="ai-chip ai-chip--more">+{{ overflow }} more</div>
  </div>
</ng-container>

<!-- ── TABLE MODE ───────────────────────────────────────────────────────────── -->
<ng-container *ngIf="mode === 'table'">
  <div class="ai-table-wrap">
    <table class="ai-table">
      <thead>
        <tr>
          <th>Action item</th>
          <th>Asset</th>
          <th>Categories</th>
          <th>Status</th>
          <th>Assigned</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of displayed">
          <td class="ai-td-item">
            <div class="ai-item-label">{{ itemLabel(item) }}</div>
            <div class="ai-item-id" *ngIf="item.actionItemId">{{ item.actionItemId }}</div>
          </td>
          <td class="ai-td-muted">
            <div *ngIf="assetRef(item) !== '—'" class="ai-mono">{{ assetRef(item) }}</div>
            <span *ngIf="item.assetName" class="ai-asset-sub">{{ item.assetName }}</span>
            <span *ngIf="assetRef(item) === '—'">—</span>
          </td>
          <td class="ai-td-cats">
            <span *ngFor="let cat of (item.assetCategories ?? [])" class="ai-cat-pill">{{ cat }}</span>
            <span *ngIf="!(item.assetCategories ?? []).length">—</span>
          </td>
          <td>
            <span *ngIf="item.status" class="ai-badge" [ngClass]="statusClass(item.status)">{{ item.status }}</span>
            <span *ngIf="!item.status">—</span>
          </td>
          <td class="ai-td-muted">{{ assignedLabel(item) }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="ai-view-all" *ngIf="overflow > 0">
    Showing {{ displayed.length }} of {{ totalCount }}
    <span class="ai-view-all-link">View all {{ totalCount }} action items &rsaquo;</span>
  </div>
</ng-container>
